import { render, staticRenderFns } from "./bkToggleUserModal.vue?vue&type=template&id=264a9634"
import script from "./bkToggleUserModal.vue?vue&type=script&lang=js"
export * from "./bkToggleUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports